import useNativePaymentMethodsAreAvailable from './useNativePaymentMethodsAreAvailable'
export default useNativePaymentMethodsAreAvailable
